module.exports = __webpack_public_path__ + "static/img/480_phase_function_Paper_PointsHejduk_Prediction.17b1b2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/480_phase_function_Paper_PointsHejduk_Prediction.png
// module id = HImV
// module chunks = 0